import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Modal from 'react-responsive-modal';
import styles from './ModalWindow.module.scss';
import 'react-responsive-modal/styles.css';

function ModalWindow(props) {
  const { size, background, shouldUseModernStyles } = props;
  const style = {};
  const classes = [styles.body];

  if (size) {
    classes.push(styles[`size-${size}`]);
  }

  if (background) {
    style.background = background;
  }

  if (shouldUseModernStyles) {
    style.borderRadius = '10px';
    style.padding = '0px';
  }

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      center={props.center}
      classNames={{ modal: styles.modal }}
      styles={{ modal: style }}
      showCloseIcon={props.showCloseIcon}
    >
      <div className={cn(classes)}>{props.children}</div>
    </Modal>
  );
}

export default ModalWindow;

ModalWindow.defaultProps = {
  center: false,
  showCloseIcon: true,
};

ModalWindow.propTypes = {
  showCloseIcon: PropTypes.bool,
  shouldUseModernStyles: PropTypes.bool,
  center: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
};
